<script>
  export let className;
</script>

<style>
  .main-crab {
    height: 34px;
    transform: translate(0px, 2px);
    width: 34px;
  }

  .welcome-crab {
    height: 64px;
    width: 64px;
  }
</style>

<svg
  class={className}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 48 48"
  width="48"
  height="48">
  <title>crab</title>
  <g class="nc-icon-wrapper">
    <path
      fill="#C94F49"
      d="M40,47h-0.00098c-0.55273-0.00049-1-0.44873-0.99902-1.00146c0-0.03809-0.04688-4.07812-2.82422-4.93945
      c-0.52832-0.16357-0.82324-0.72363-0.65918-1.25146c0.16309-0.52686,0.72266-0.82324,1.25098-0.65869
      C40.95898,40.44873,41,45.7749,41,46.00098C40.99902,46.55322,40.55176,47,40,47z" />
    <path
      fill="#C94F49"
      d="M33.55957,27.31885c-0.39355,0-0.7666-0.23438-0.92578-0.62109
      c-0.20898-0.51123,0.03516-1.09521,0.54688-1.30469C35.05762,24.62354,37,21.64795,37,18c0-0.55225,0.44727-1,1-1s1,0.44775,1,1
      c0,4.1543-2.12891,8.0415-5.06152,9.24365C33.81445,27.29443,33.68652,27.31885,33.55957,27.31885z" />
    <path
      fill="#C94F49"
      d="M8,47c-0.55176,0-0.99902-0.44678-1-0.99902c0-0.22607,0.04102-5.55225,4.23242-6.85205
      c0.53027-0.16357,1.08789,0.13184,1.25098,0.65869c0.16406,0.52783-0.13086,1.08789-0.65918,1.25146
      C9.02734,41.92676,9,45.95801,9,45.99854C9.00098,46.55127,8.55371,46.99951,8.00098,47H8z" />
    <path
      fill="#C94F49"
      d="M14.44043,27.31885c-0.12695,0-0.25488-0.02441-0.37891-0.0752C11.12891,26.0415,9,22.1543,9,18
      c0-0.55225,0.44727-1,1-1s1,0.44775,1,1c0,3.64795,1.94238,6.62354,3.81934,7.39307
      c0.51172,0.20947,0.75586,0.79346,0.54688,1.30469C15.20703,27.08447,14.83398,27.31885,14.44043,27.31885z" />
    <path
      fill="#E86C60"
      d="M24,45C12.57129,45,3.62793,35.08643,3.25293,34.66455c-0.33691-0.37891-0.33691-0.9502,0-1.3291
      C3.62793,32.91357,12.57129,23,24,23s20.37207,9.91357,20.74707,10.33545c0.33887,0.38037,0.33691,0.9541-0.00293,1.33252
      C44.36523,35.08984,35.33398,45,24,45z" />
    <path
      fill="#E86C60"
      d="M18.97999,10.39734c-0.01689-0.25579-0.17371-0.4812-0.40756-0.58633
      c-0.23385-0.10436-0.50556-0.07232-0.70896,0.08589c-1.41453,1.10296-4.40047,2.03463-6.52065,2.03463
      c-0.86911,0-1.5335-0.16527-1.8214-0.45352c-1.05977-1.0597-0.0845-6.20569,1.58146-8.34274
      c0.15752-0.20202,0.1906-0.47476,0.08519-0.70861c-0.10478-0.23385-0.33046-0.39061-0.58598-0.40749
      C8.00211,1.8512,5.48317,2.79263,3.6489,4.6269c-3.50762,3.50805-3.50762,9.21559,0,12.72364
      c1.69911,1.69939,3.95852,2.63514,6.36182,2.63514c2.40337,0,4.66272-0.93575,6.36182-2.63514
      C18.20003,15.52333,19.15031,12.98888,18.97999,10.39734z" />
    <path
      fill="#E86C60"
      d="M29.02001,10.39734c0.01689-0.25579,0.17371-0.4812,0.40756-0.58633
      c0.23385-0.10436,0.50556-0.07232,0.70896,0.08589c1.41453,1.10296,4.40047,2.03463,6.52065,2.03463
      c0.86911,0,1.5335-0.16527,1.8214-0.45352c1.05977-1.0597,0.0845-6.20569-1.58146-8.34274
      c-0.15752-0.20202-0.1906-0.47476-0.08519-0.70861c0.10478-0.23385,0.33046-0.39061,0.58598-0.40749
      c2.59998-0.16797,5.11893,0.77346,6.9532,2.60773c3.50763,3.50805,3.50763,9.21559,0,12.72364
      c-1.69911,1.69939-3.95852,2.63514-6.36182,2.63514c-2.40336,0-4.66272-0.93575-6.36182-2.63514
      C29.79997,15.52333,28.84969,12.98888,29.02001,10.39734z" />
    <circle fill="#444444" cx="18" cy="31" r="2" />
    <circle fill="#444444" cx="30" cy="31" r="2" />
  </g>
</svg>
